/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-no-constructed-context-values */
import { Layout, FloatButton, Tooltip } from 'antd';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import React, { createContext, useRef, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
// import { Accessibility } from 'accessibility';
import Accessibility from 'accessibility/dist/main';
import { useTranslation } from 'react-i18next';
import Icons from '../../configs/icon.config';
import View from '../../view';
import MobileMenu from '../template/MobileMenu';
import Topbar from '../template/Topbar';
import SideNav from '../template/SideNav/SideNav';
import CustomFooter from '../template/Footer/Footer';
import GuidedTour from '../ui/Tour/GuidedTour';
import ScrollDown from '../ui/ScrollDown';
import { commonState, setFloatButtonCount } from '../../app/base/commonSlice';
import './styles.scss';

import Feedback from '../ui/Feedback/Feedback/Feedback';
import Notice from '../ui/Notice';
import UserIdleLogout from '../ui/UserIdleLogout/UserIdleLogout';
import Chatbot from '../Chatbot/Chatbot';
import { useDashBoardContentQuery } from '../../view/dashboard/store/dashboardSlice';

const { Footer, Content } = Layout;
export const TourContext = createContext({});

const contentStyle: React.CSSProperties = {
  lineHeight: '2.6rem',
  padding: '2.5rem 3rem',
  position: 'relative',
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface

function AppLayout() {
  const menuRef = useRef(null);
  const favMenuRef = useRef(null);
  const searchRef = useRef(null);
  const notificationsRef = useRef(null);
  const rightSideRef = useRef(null);
  const impContactsRef = useRef(null);
  const darkModeRef = useRef(null);
  const languageRef = useRef(null);
  const { data: dashboardContentData } = useDashBoardContentQuery();
  const { t } = useTranslation();

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const {
    isAdmin,
    openVideoDialog,
    isBrowserTabOpen,
    floatButtonCount,
    isNoticeOpen,
  } = useSelector(commonState);
  const dispatch = useDispatch();

  const steps = [
    {
      title: 'মেন্যুতে যা থাকবে - Menu items',
      description: (
        <div>
          <div className="mb-6">
            এখানে আপনার প্রয়োজনীয় অ্যাপ/লিংক খুঁজুন। আগের মাই-ব্র্যাকের বক্স
            গুলো এখানে শ্রেণীবিভক্ত ভাবে সাজানো রয়েছে।
          </div>
          <div>
            Find your required apps/links here. The boxes from the older app are
            now organized and grouped here relevantly.
          </div>
        </div>
      ),
      placement: 'right',
      target: () => menuRef.current,
    },
    {
      title: 'আপনার প্রিয় মেন্যু গুলো -  Your favourite menues',
      description: (
        <div>
          <div className="mb-6">
            আপনার পছন্দের মেন্যু গুলোকে প্রিয় তালিকায় যোগ করুন যাতে করে তাড়াতাড়ি
            ওগুলো খুঁজে পান। প্রতিটি মেন্যুর সামনের তারকা চিহ্নটি ক্লিক করে একে
            প্রিয় লিস্টে যুক্ত করুন।
            {Icons.star}
          </div>
          <div>
            Now, you can add items to your Favourites menu to visit them faster.
            Click the star icon (as shown below) next to a menu item to add to
            favourites: {Icons.star}
          </div>
        </div>
      ),
      placement: 'right',
      target: () => favMenuRef.current,
    },
    {
      title: 'খুঁজুন - Search',
      description: (
        <div>
          <div className="mb-6">
            মাই-ব্র্যাকের ভেতরে বা আপনার সহকর্মীদের খুঁজুন। কম সময়ে যে কোন কিছু
            খুঁজে পেতে এটা আপনাকে সাহায্য করবে।
          </div>
          <div>
            Search within myBrac or among the BRAC employees. Try it, it's fun.
          </div>
        </div>
      ),
      placement: 'bottom',
      target: () => searchRef.current,
    },
    {
      title: 'বিজ্ঞপ্তি - Notifications',
      description: (
        <div>
          <div className="mb-6">
            এখানে নোটিফিকেশন গুলো দেখুন। নীল একটা বিন্দু দেখা গেলে বুঝবেন, নতুন
            নোটিফিকেশন আছে।
          </div>
          <div>
            {' '}
            Find necessary notifications here. Don't forget to check when you
            see the blue bubble.
          </div>
        </div>
      ),
      placement: 'bottom',
      target: () => notificationsRef.current,
    },
    {
      title: 'আলোর ধরন পাল্টান - Switch the theme',
      description: (
        <div>
          <div className="mb-6">
            এই বাটনটি ব্যবহার করে আপনি উজ্জ্বল এবং অন্ধকার আলোর মাই-ব্র্যাক
            দেখতে পাবেন।
          </div>
          <div>
            Use this button to switch the system UI between light theme and dark
            theme.
          </div>
        </div>
      ),
      placement: 'bottom',
      target: () => darkModeRef.current,
    },
    {
      title: 'ভাষা পরিবর্তন করুন - Switch the language',
      description: (
        <div>
          <div className="mb-6">
            এই বাটনটি ব্যবহার করে আপনি বাংলা এবং ইংরেজী ভাষায় মাই-ব্র্যাক দেখতে
            পাবেন।
          </div>
          <div>
            Use this button to switch the system language between English and
            Bangla.
          </div>
        </div>
      ),
      placement: 'bottom',
      target: () => languageRef.current,
    },
    {
      title: 'আপনার ড্যাশবোর্ড - Dashboard area',
      description: (
        <div>
          <div className="mb-6">
            ব্র্যাকের নিত্য-নতুন তথ্যের জন্যে এখানে চোখ রাখুন। আসন্ন অনুষ্ঠান
            সমূহ, খবরাদি এবং মজার কিছু তথ্য এখানে পাবেন।
          </div>
          <div>
            Find your daily dose of BRAC in this section. Find the upcoming
            events, news, and interesting facts here.
          </div>
        </div>
      ),
      placement: 'center',
      target: () => rightSideRef.current,
    },
    {
      title: 'জরুরী যোগাযোগের তালিকা - Important contacts',
      description: (
        <div>
          <div className="mb-6">
            জরুরী প্রয়োজনে যোগাযোগের নম্বর, বি-এল-সি এবং বি-ডি-সি দের সাথে
            যোগাযোগের নম্বর এখানে পাবেন। তিন টি তালিকার যেকোনটিতেই আপনি খুঁজে
            দেখার সুযোগ পাবেন।
          </div>
          <div>
            Find the emergency BRAC contacts and contact numbers of BLCs and
            BDCs here. Click to open the full list and search the contact you
            are looking for.
          </div>
        </div>
      ),
      placement: 'bottom',
      target: () => impContactsRef.current,
    },
  ];

  // Accessibility
  const options = {
    icon: {
      dimensions: {
        width: { size: 35, units: 'px' },
        height: { size: 35, units: 'px' },
      },
      position: {
        bottom: { size: 35, units: 'px' },
        right: { size: 25, units: 'px' },
      },
      backgroundColor: '#D10D74',
      img: 'accessible',
      zIndex: '50',
      circular: true,
    },
  };

  useEffect(() => {
    // eslint-disable-next-line no-new
    new Accessibility(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Scroll for top button

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Float button count

  useEffect(() => {
    if (!isEmpty(dashboardContentData?.header_notices)) {
      if (!isNoticeOpen) {
        if (!(scrollPosition <= 0)) {
          dispatch(setFloatButtonCount(3));
        } else {
          dispatch(setFloatButtonCount(2));
        }
      } else if (!(scrollPosition <= 0)) {
        dispatch(setFloatButtonCount(2));
      } else {
        dispatch(setFloatButtonCount(1));
      }
    } else if (!(scrollPosition <= 0)) {
      dispatch(setFloatButtonCount(2));
    } else {
      dispatch(setFloatButtonCount(1));
    }
  }, [
    dispatch,
    dashboardContentData?.header_notices,
    isNoticeOpen,
    scrollPosition,
  ]);

  return (
    <TourContext.Provider
      value={{
        menuRef,
        favMenuRef,
        searchRef,
        notificationsRef,
        rightSideRef,
        impContactsRef,
        darkModeRef,
        languageRef,
      }}
    >
      {/* user will be autometiclly logged out if he/she idle 30 minutes */}
      {(!openVideoDialog || (openVideoDialog && !isBrowserTabOpen)) && (
        <UserIdleLogout />
      )}

      {/* <FeedbackButton /> */}
      <Layout>
        {!isMobile && <SideNav />}
        <Layout className="relative">
          <Topbar />

          {/* notice area start */}
          {!isEmpty(dashboardContentData?.header_notices) && (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {dashboardContentData?.header_notices?.content_en && (
                <Notice
                  contentEn={dashboardContentData?.header_notices?.content_en}
                  contentBn={dashboardContentData?.header_notices?.content_bn}
                />
              )}
            </>
          )}

          {/* notice area end  */}

          <Content style={contentStyle}>
            {!isAdmin ? <Chatbot /> : ''}

            {!isAdmin ? <Feedback /> : ''}
            <div
              className={`float-button flex fixed bottom-[25px] right-5 bg-white  ${
                floatButtonCount === 3
                  ? 'w-[150px]'
                  : floatButtonCount === 2
                  ? 'w-[105px]'
                  : 'w-[60px]'
              } h-[55px] rounded-lg border-2 z-30 shadow-xl`}
            >
              <div />
              <div />
            </div>
            <View />
          </Content>

          <Footer
            className={classNames('p-0', {
              'mb-[8rem]': isMobile,
            })}
          >
            <CustomFooter />
            {!isAdmin && <ScrollDown />}
          </Footer>
        </Layout>
        {/* mobile menu  */}
        {isMobile && <MobileMenu />}
        {/* application tour  */}
        <GuidedTour steps={steps} />
        <div className="top-button">
          <Tooltip title={t('button.top')}>
            <FloatButton.BackTop
              style={{ color: 'white', right: 69, bottom: 35, fontSize: 15 }}
              className="button bg-[#D10D74] hover:bg-pink-500 h-[35px] w-[35px]"
              shape="circle"
              icon={
                <div className="text-white text-[26px] absolute bottom-[4px] left-[5px]">
                  {Icons.topButton}
                </div>
              }
              visibilityHeight={100}
            />
          </Tooltip>
        </div>
      </Layout>
    </TourContext.Provider>
  );
}

export default memo(AppLayout);
